export default [
    {
        lat: 47.715,
        lng: 10.7,
    },
    {
        lat: 47.755,
        lng: 10.72,
    },
    {
        lat: 47.77,
        lng: 10.715,
    },
    {
        lat: 47.785,
        lng: 10.73,
    },
    {
        lat: 47.815,
        lng: 10.725,
    },
    {
        lat: 47.83,
        lng: 10.74,
    },
    {
        lat: 47.845,
        lng: 10.73,
    },
    {
        lat: 47.865,
        lng: 10.73,
    },
    {
        lat: 47.88,
        lng: 10.74,
    },
    {
        lat: 47.88,
        lng: 10.75,
    },
    {
        lat: 47.895,
        lng: 10.755,
    },
    {
        lat: 47.945,
        lng: 10.755,
    },
    {
        lat: 47.955,
        lng: 10.775,
    },
    {
        lat: 47.965,
        lng: 10.775,
    },
    {
        lat: 47.985,
        lng: 10.795,
    },
    {
        lat: 48.02,
        lng: 10.785,
    },
    {
        lat: 48.015,
        lng: 10.755,
    },
    {
        lat: 48.035,
        lng: 10.735,
    },
    {
        lat: 48.055,
        lng: 10.735,
    },
    {
        lat: 48.08,
        lng: 10.765,
    },
    {
        lat: 48.095,
        lng: 10.77,
    },
    {
        lat: 48.095,
        lng: 10.78,
    },
    {
        lat: 48.125,
        lng: 10.765,
    },
    {
        lat: 48.155,
        lng: 10.765,
    },
    {
        lat: 48.17,
        lng: 10.775,
    },
    {
        lat: 48.17,
        lng: 10.835,
    },
    {
        lat: 48.18,
        lng: 10.85,
    },
    {
        lat: 48.21,
        lng: 10.865,
    },
    {
        lat: 48.215,
        lng: 10.88,
    },
    {
        lat: 48.25,
        lng: 10.885,
    },
    {
        lat: 48.26,
        lng: 10.9,
    },
    {
        lat: 48.255,
        lng: 10.94,
    },
    {
        lat: 48.225,
        lng: 10.965,
    },
    {
        lat: 48.23,
        lng: 10.995,
    },
    {
        lat: 48.22,
        lng: 11.02,
    },
    {
        lat: 48.23,
        lng: 11.015,
    },
    {
        lat: 48.245,
        lng: 11.025,
    },
    {
        lat: 48.265,
        lng: 11.025,
    },
    {
        lat: 48.275,
        lng: 11.04,
    },
    {
        lat: 48.29,
        lng: 11.045,
    },
    {
        lat: 48.3,
        lng: 11.06,
    },
    {
        lat: 48.295,
        lng: 11.09,
    },
    {
        lat: 48.34,
        lng: 11.115,
    },
    {
        lat: 48.345,
        lng: 11.14,
    },
    {
        lat: 48.375,
        lng: 11.145,
    },
    {
        lat: 48.395,
        lng: 11.17,
    },
    {
        lat: 48.405,
        lng: 11.16,
    },
    {
        lat: 48.43,
        lng: 11.16,
    },
    {
        lat: 48.45,
        lng: 11.205,
    },
    {
        lat: 48.45,
        lng: 11.23,
    },
    {
        lat: 48.46,
        lng: 11.235,
    },
    {
        lat: 48.47,
        lng: 11.23,
    },
    {
        lat: 48.47,
        lng: 11.215,
    },
    {
        lat: 48.485,
        lng: 11.195,
    },
    {
        lat: 48.51,
        lng: 11.19,
    },
    {
        lat: 48.52,
        lng: 11.175,
    },
    {
        lat: 48.53,
        lng: 11.125,
    },
    {
        lat: 48.54,
        lng: 11.11,
    },
    {
        lat: 48.56,
        lng: 11.105,
    },
    {
        lat: 48.575,
        lng: 11.115,
    },
    {
        lat: 48.585,
        lng: 11.105,
    },
    {
        lat: 48.58,
        lng: 11.045,
    },
    {
        lat: 48.59,
        lng: 11.025,
    },
    {
        lat: 48.605,
        lng: 11.015,
    },
    {
        lat: 48.605,
        lng: 11.005,
    },
    {
        lat: 48.62,
        lng: 11,
    },
    {
        lat: 48.635,
        lng: 11.005,
    },
    {
        lat: 48.68,
        lng: 10.965,
    },
    {
        lat: 48.75,
        lng: 10.965,
    },
    {
        lat: 48.765,
        lng: 10.945,
    },
    {
        lat: 48.785,
        lng: 10.945,
    },
    {
        lat: 48.81,
        lng: 10.925,
    },
    {
        lat: 48.825,
        lng: 10.93,
    },
    {
        lat: 48.84,
        lng: 10.95,
    },
    {
        lat: 48.845,
        lng: 10.925,
    },
    {
        lat: 48.865,
        lng: 10.915,
    },
    {
        lat: 48.88,
        lng: 10.925,
    },
    {
        lat: 48.885,
        lng: 10.955,
    },
    {
        lat: 48.9,
        lng: 10.97,
    },
    {
        lat: 48.905,
        lng: 11.01,
    },
    {
        lat: 48.97,
        lng: 11.055,
    },
    {
        lat: 48.985,
        lng: 11.09,
    },
    {
        lat: 48.985,
        lng: 11.125,
    },
    {
        lat: 49,
        lng: 11.125,
    },
    {
        lat: 49.03,
        lng: 11.145,
    },
    {
        lat: 49.035,
        lng: 11.165,
    },
    {
        lat: 49.045,
        lng: 11.165,
    },
    {
        lat: 49.065,
        lng: 11.19,
    },
    {
        lat: 49.075,
        lng: 11.26,
    },
    {
        lat: 49.06,
        lng: 11.275,
    },
    {
        lat: 49.045,
        lng: 11.275,
    },
    {
        lat: 49.03,
        lng: 11.315,
    },
    {
        lat: 49.02,
        lng: 11.32,
    },
    {
        lat: 49.04,
        lng: 11.34,
    },
    {
        lat: 49.035,
        lng: 11.365,
    },
    {
        lat: 49.05,
        lng: 11.38,
    },
    {
        lat: 49.07,
        lng: 11.365,
    },
    {
        lat: 49.085,
        lng: 11.365,
    },
    {
        lat: 49.105,
        lng: 11.38,
    },
    {
        lat: 49.11,
        lng: 11.395,
    },
    {
        lat: 49.085,
        lng: 11.435,
    },
    {
        lat: 49.085,
        lng: 11.48,
    },
    {
        lat: 49.095,
        lng: 11.49,
    },
    {
        lat: 49.09,
        lng: 11.545,
    },
    {
        lat: 49.07,
        lng: 11.565,
    },
    {
        lat: 49.055,
        lng: 11.565,
    },
    {
        lat: 49.05,
        lng: 11.555,
    },
    {
        lat: 49.025,
        lng: 11.56,
    },
    {
        lat: 49.02,
        lng: 11.57,
    },
    {
        lat: 49.01,
        lng: 11.57,
    },
    {
        lat: 49,
        lng: 11.595,
    },
    {
        lat: 48.98,
        lng: 11.6,
    },
    {
        lat: 48.965,
        lng: 11.615,
    },
    {
        lat: 48.965,
        lng: 11.64,
    },
    {
        lat: 48.955,
        lng: 11.65,
    },
    {
        lat: 48.95,
        lng: 11.675,
    },
    {
        lat: 48.955,
        lng: 11.69,
    },
    {
        lat: 48.945,
        lng: 11.705,
    },
    {
        lat: 48.95,
        lng: 11.71,
    },
    {
        lat: 48.945,
        lng: 11.745,
    },
    {
        lat: 48.925,
        lng: 11.75,
    },
    {
        lat: 48.91,
        lng: 11.74,
    },
    {
        lat: 48.905,
        lng: 11.755,
    },
    {
        lat: 48.87,
        lng: 11.765,
    },
    {
        lat: 48.855,
        lng: 11.755,
    },
    {
        lat: 48.85,
        lng: 11.74,
    },
    {
        lat: 48.845,
        lng: 11.745,
    },
    {
        lat: 48.835,
        lng: 11.74,
    },
    {
        lat: 48.825,
        lng: 11.76,
    },
    {
        lat: 48.795,
        lng: 11.76,
    },
    {
        lat: 48.78,
        lng: 11.755,
    },
    {
        lat: 48.765,
        lng: 11.735,
    },
    {
        lat: 48.745,
        lng: 11.735,
    },
    {
        lat: 48.73,
        lng: 11.69,
    },
    {
        lat: 48.71,
        lng: 11.685,
    },
    {
        lat: 48.695,
        lng: 11.715,
    },
    {
        lat: 48.665,
        lng: 11.72,
    },
    {
        lat: 48.655,
        lng: 11.735,
    },
    {
        lat: 48.63,
        lng: 11.73,
    },
    {
        lat: 48.62,
        lng: 11.76,
    },
    {
        lat: 48.635,
        lng: 11.775,
    },
    {
        lat: 48.635,
        lng: 11.8,
    },
    {
        lat: 48.605,
        lng: 11.86,
    },
    {
        lat: 48.61,
        lng: 11.89,
    },
    {
        lat: 48.595,
        lng: 11.935,
    },
    {
        lat: 48.6,
        lng: 11.95,
    },
    {
        lat: 48.595,
        lng: 11.975,
    },
    {
        lat: 48.55,
        lng: 11.995,
    },
    {
        lat: 48.545,
        lng: 11.99,
    },
    {
        lat: 48.515,
        lng: 11.995,
    },
    {
        lat: 48.515,
        lng: 12.02,
    },
    {
        lat: 48.505,
        lng: 12.03,
    },
    {
        lat: 48.46,
        lng: 12.025,
    },
    {
        lat: 48.44,
        lng: 12.04,
    },
    {
        lat: 48.45,
        lng: 12.07,
    },
    {
        lat: 48.445,
        lng: 12.165,
    },
    {
        lat: 48.425,
        lng: 12.19,
    },
    {
        lat: 48.38,
        lng: 12.215,
    },
    {
        lat: 48.36,
        lng: 12.25,
    },
    {
        lat: 48.345,
        lng: 12.255,
    },
    {
        lat: 48.35,
        lng: 12.305,
    },
    {
        lat: 48.36,
        lng: 12.315,
    },
    {
        lat: 48.355,
        lng: 12.345,
    },
    {
        lat: 48.365,
        lng: 12.35,
    },
    {
        lat: 48.365,
        lng: 12.365,
    },
    {
        lat: 48.38,
        lng: 12.38,
    },
    {
        lat: 48.385,
        lng: 12.405,
    },
    {
        lat: 48.425,
        lng: 12.41,
    },
    {
        lat: 48.435,
        lng: 12.42,
    },
    {
        lat: 48.435,
        lng: 12.46,
    },
    {
        lat: 48.45,
        lng: 12.475,
    },
    {
        lat: 48.44,
        lng: 12.555,
    },
    {
        lat: 48.405,
        lng: 12.59,
    },
    {
        lat: 48.4,
        lng: 12.61,
    },
    {
        lat: 48.38,
        lng: 12.62,
    },
    {
        lat: 48.36,
        lng: 12.655,
    },
    {
        lat: 48.365,
        lng: 12.7,
    },
    {
        lat: 48.35,
        lng: 12.71,
    },
    {
        lat: 48.34,
        lng: 12.74,
    },
    {
        lat: 48.35,
        lng: 12.775,
    },
    {
        lat: 48.345,
        lng: 12.805,
    },
    {
        lat: 48.33,
        lng: 12.84,
    },
    {
        lat: 48.315,
        lng: 12.845,
    },
    {
        lat: 48.305,
        lng: 12.87,
    },
    {
        lat: 48.29,
        lng: 12.88,
    },
    {
        lat: 48.285,
        lng: 12.905,
    },
    {
        lat: 48.255,
        lng: 12.925,
    },
    {
        lat: 48.24,
        lng: 12.92,
    },
    {
        lat: 48.225,
        lng: 12.94,
    },
    {
        lat: 48.225,
        lng: 12.955,
    },
    {
        lat: 48.2,
        lng: 12.965,
    },
    {
        lat: 48.185,
        lng: 12.95,
    },
    {
        lat: 48.185,
        lng: 12.88,
    },
    {
        lat: 48.15,
        lng: 12.86,
    },
    {
        lat: 48.13,
        lng: 12.83,
    },
    {
        lat: 48.13,
        lng: 12.815,
    },
    {
        lat: 48.105,
        lng: 12.8,
    },
    {
        lat: 48.105,
        lng: 12.775,
    },
    {
        lat: 48.09,
        lng: 12.77,
    },
    {
        lat: 48.04,
        lng: 12.855,
    },
    {
        lat: 48.02,
        lng: 12.875,
    },
    {
        lat: 47.98,
        lng: 12.885,
    },
    {
        lat: 47.98,
        lng: 12.91,
    },
    {
        lat: 47.965,
        lng: 12.945,
    },
    {
        lat: 47.95,
        lng: 12.96,
    },
    {
        lat: 47.935,
        lng: 12.96,
    },
    {
        lat: 47.915,
        lng: 12.985,
    },
    {
        lat: 47.905,
        lng: 12.985,
    },
    {
        lat: 47.855,
        lng: 13.025,
    },
    {
        lat: 47.835,
        lng: 13.025,
    },
    {
        lat: 47.775,
        lng: 12.965,
    },
    {
        lat: 47.755,
        lng: 12.965,
    },
    {
        lat: 47.73,
        lng: 12.95,
    },
    {
        lat: 47.73,
        lng: 12.99,
    },
    {
        lat: 47.745,
        lng: 13.005,
    },
    {
        lat: 47.73,
        lng: 13.06,
    },
    {
        lat: 47.71,
        lng: 13.075,
    },
    {
        lat: 47.71,
        lng: 13.085,
    },
    {
        lat: 47.695,
        lng: 13.1,
    },
    {
        lat: 47.67,
        lng: 13.1,
    },
    {
        lat: 47.655,
        lng: 13.115,
    },
    {
        lat: 47.63,
        lng: 13.12,
    },
    {
        lat: 47.6,
        lng: 13.09,
    },
    {
        lat: 47.575,
        lng: 13.09,
    },
    {
        lat: 47.565,
        lng: 13.075,
    },
    {
        lat: 47.55,
        lng: 13.075,
    },
    {
        lat: 47.535,
        lng: 13.06,
    },
    {
        lat: 47.505,
        lng: 13.07,
    },
    {
        lat: 47.48,
        lng: 13.065,
    },
    {
        lat: 47.47,
        lng: 13.055,
    },
    {
        lat: 47.47,
        lng: 13.04,
    },
    {
        lat: 47.445,
        lng: 13.015,
    },
    {
        lat: 47.46,
        lng: 12.94,
    },
    {
        lat: 47.485,
        lng: 12.885,
    },
    {
        lat: 47.505,
        lng: 12.865,
    },
    {
        lat: 47.51,
        lng: 12.845,
    },
    {
        lat: 47.525,
        lng: 12.835,
    },
    {
        lat: 47.525,
        lng: 12.81,
    },
    {
        lat: 47.54,
        lng: 12.78,
    },
    {
        lat: 47.565,
        lng: 12.76,
    },
    {
        lat: 47.59,
        lng: 12.76,
    },
    {
        lat: 47.605,
        lng: 12.775,
    },
    {
        lat: 47.615,
        lng: 12.775,
    },
    {
        lat: 47.62,
        lng: 12.76,
    },
    {
        lat: 47.66,
        lng: 12.73,
    },
    {
        lat: 47.655,
        lng: 12.725,
    },
    {
        lat: 47.66,
        lng: 12.67,
    },
    {
        lat: 47.65,
        lng: 12.66,
    },
    {
        lat: 47.655,
        lng: 12.615,
    },
    {
        lat: 47.615,
        lng: 12.59,
    },
    {
        lat: 47.61,
        lng: 12.575,
    },
    {
        lat: 47.615,
        lng: 12.535,
    },
    {
        lat: 47.605,
        lng: 12.52,
    },
    {
        lat: 47.605,
        lng: 12.49,
    },
    {
        lat: 47.625,
        lng: 12.475,
    },
    {
        lat: 47.635,
        lng: 12.45,
    },
    {
        lat: 47.665,
        lng: 12.42,
    },
    {
        lat: 47.675,
        lng: 12.42,
    },
    {
        lat: 47.665,
        lng: 12.385,
    },
    {
        lat: 47.675,
        lng: 12.31,
    },
    {
        lat: 47.67,
        lng: 12.285,
    },
    {
        lat: 47.66,
        lng: 12.275,
    },
    {
        lat: 47.66,
        lng: 12.245,
    },
    {
        lat: 47.69,
        lng: 12.22,
    },
    {
        lat: 47.69,
        lng: 12.205,
    },
    {
        lat: 47.68,
        lng: 12.195,
    },
    {
        lat: 47.65,
        lng: 12.22,
    },
    {
        lat: 47.62,
        lng: 12.23,
    },
    {
        lat: 47.595,
        lng: 12.225,
    },
    {
        lat: 47.585,
        lng: 12.21,
    },
    {
        lat: 47.58,
        lng: 12.17,
    },
    {
        lat: 47.59,
        lng: 12.16,
    },
    {
        lat: 47.585,
        lng: 12.12,
    },
    {
        lat: 47.595,
        lng: 12.07,
    },
    {
        lat: 47.59,
        lng: 12.015,
    },
    {
        lat: 47.6,
        lng: 12.005,
    },
    {
        lat: 47.6,
        lng: 11.99,
    },
    {
        lat: 47.585,
        lng: 11.87,
    },
    {
        lat: 47.57,
        lng: 11.865,
    },
    {
        lat: 47.56,
        lng: 11.85,
    },
    {
        lat: 47.57,
        lng: 11.79,
    },
    {
        lat: 47.565,
        lng: 11.645,
    },
    {
        lat: 47.56,
        lng: 11.62,
    },
    {
        lat: 47.55,
        lng: 11.61,
    },
    {
        lat: 47.52,
        lng: 11.61,
    },
    {
        lat: 47.5,
        lng: 11.59,
    },
    {
        lat: 47.485,
        lng: 11.52,
    },
    {
        lat: 47.49,
        lng: 11.435,
    },
    {
        lat: 47.485,
        lng: 11.425,
    },
    {
        lat: 47.455,
        lng: 11.44,
    },
    {
        lat: 47.435,
        lng: 11.44,
    },
    {
        lat: 47.425,
        lng: 11.43,
    },
    {
        lat: 47.43,
        lng: 11.35,
    },
    {
        lat: 47.41,
        lng: 11.31,
    },
    {
        lat: 47.39,
        lng: 11.305,
    },
    {
        lat: 47.38,
        lng: 11.285,
    },
    {
        lat: 47.375,
        lng: 11.215,
    },
    {
        lat: 47.395,
        lng: 11.2,
    },
    {
        lat: 47.41,
        lng: 11.2,
    },
    {
        lat: 47.4,
        lng: 11.155,
    },
    {
        lat: 47.375,
        lng: 11.125,
    },
    {
        lat: 47.375,
        lng: 10.975,
    },
    {
        lat: 47.395,
        lng: 10.95,
    },
    {
        lat: 47.435,
        lng: 10.95,
    },
    {
        lat: 47.45,
        lng: 10.92,
    },
    {
        lat: 47.465,
        lng: 10.91,
    },
    {
        lat: 47.46,
        lng: 10.865,
    },
    {
        lat: 47.475,
        lng: 10.85,
    },
    {
        lat: 47.51,
        lng: 10.85,
    },
    {
        lat: 47.52,
        lng: 10.87,
    },
    {
        lat: 47.555,
        lng: 10.85,
    },
    {
        lat: 47.585,
        lng: 10.855,
    },
    {
        lat: 47.6,
        lng: 10.88,
    },
    {
        lat: 47.6,
        lng: 10.905,
    },
    {
        lat: 47.61,
        lng: 10.92,
    },
    {
        lat: 47.62,
        lng: 10.89,
    },
    {
        lat: 47.635,
        lng: 10.885,
    },
    {
        lat: 47.645,
        lng: 10.85,
    },
    {
        lat: 47.635,
        lng: 10.83,
    },
    {
        lat: 47.64,
        lng: 10.775,
    },
    {
        lat: 47.65,
        lng: 10.76,
    },
    {
        lat: 47.67,
        lng: 10.76,
    },
    {
        lat: 47.66,
        lng: 10.735,
    },
    {
        lat: 47.665,
        lng: 10.715,
    },
    {
        lat: 47.685,
        lng: 10.71,
    },
    {
        lat: 47.7,
        lng: 10.695,
    },
    {
        lat: 47.715,
        lng: 10.7,
    },
];
